import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const viewsText = comic.views >= 10000
    ? `${(comic.views / 10000).toFixed(1)}万`
    : comic.views.toString();

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className={`relative overflow-hidden ${size === 'large' ? 'aspect-[3/4]' : 'aspect-[2/3]'}`}>
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 免费漫画在线免费阅读`}
          title={`${comic.title} - 星球漫画免费全集`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2">
          <span className={`text-xs px-2 py-1 rounded-full whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute top-2 left-2">
          <span className="text-xs bg-background-50/90 text-foreground-900 px-2 py-1 rounded-full flex items-center gap-1 whitespace-nowrap">
            <i className="ri-star-fill text-primary-500 text-xs"></i>
            {comic.rating}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-heading text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author}</p>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-eye-line text-xs"></i>
            {viewsText}
          </span>
          <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
            {comic.tags[0]}
          </span>
        </div>
      </div>
    </Link>
  );
}